import { Check } from '../check';
import { Employee } from '../employee';

export class NotificationRequest {
  constructor(
    public hash: string,
    public user: Employee,
    public startTime: number,
    public endTime: number,
    public check: Check
  ) { }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/aux/notification-request.ts